import { Price } from '../../price/Price';
import { MoreProductsBadge, ProductContent, ProductsPreviewContainer, Title } from './styles';
import { ProductsPreviewProps } from './types';

export const ProductsPreview = ({ products, onClick }: ProductsPreviewProps) => {
    const availableProducts = products.filter((product) => !product.isUnavailable);

    if (!availableProducts.length) {
        return null;
    }

    const firstProduct = availableProducts[0];
    const { title, priceInfo, fintechDiscount, personalDiscount } = firstProduct;
    const moreProductsCount = availableProducts.length - 1;

    return (
        <ProductsPreviewContainer onClick={onClick}>
            <ProductContent>
                <Title>{title}</Title>
                <Price
                    priceInfo={priceInfo}
                    variant="body2"
                    fintechDiscount={fintechDiscount}
                    fintechDiscountOptions={{
                        hideTooltip: true,
                    }}
                    personalDiscount={personalDiscount}
                />
            </ProductContent>
            {moreProductsCount > 0 ? (
                <MoreProductsBadge>{`+${moreProductsCount}`}</MoreProductsBadge>
            ) : null}
        </ProductsPreviewContainer>
    );
};
